export const WORKSPACE_GROUND_STATION = 'ground-station'
export const WORKSPACE_ADMIN = 'admin'
export const WORKSPACE_SETTINGS = 'settings'

export const GROUND_STATION_ENTRY = '/home/index'
export const ADMIN_ENTRY = '/model/index'

/**
 * 统一判断路由所属工作区。
 * 地面站页面显式声明 workspace；其余终端业务路由统一归入后台管理。
 */
export function getRouteWorkspace (route = {}) {
  if (route.meta && route.meta.workspace) return route.meta.workspace
  const path = String(route.path || '')
  return path === '/home' || path.startsWith('/home/')
    ? WORKSPACE_GROUND_STATION
    : WORKSPACE_ADMIN
}

/**
 * 返回指定工作区内第一个可见且有权限访问的路由。
 */
export function findAccessibleWorkspaceEntry (routeList = [], workspace, canAccess = () => true) {
  for (const route of routeList) {
    const meta = route.meta || {}
    if (meta.hidden === true || getRouteWorkspace(route) !== workspace || !canAccess(meta)) continue
    if (Array.isArray(route.children) && route.children.length) {
      const childEntry = findAccessibleWorkspaceEntry(route.children, workspace, canAccess)
      if (childEntry) return childEntry
    }
    if (route.path && route.path !== '/' && route.path !== '*') return route.redirect || route.path
  }
  return ''
}

/** 返回统一终端外壳下的业务路由，避免登录和导航各自查找一遍。 */
export function getTerminalRouteList (router) {
  const routes = router && router.options && Array.isArray(router.options.routes)
    ? router.options.routes
    : []
  const terminalRoute = routes.find(route => route.meta && route.meta.terminalShell)
  return terminalRoute && Array.isArray(terminalRoute.children) ? terminalRoute.children : []
}

/**
 * 登录后的统一落点：优先地面站；无终端概况权限时进入首个可访问后台页面。
 */
export function findAccessibleTerminalEntry (router, canAccess = () => true, fallback = '') {
  const routes = getTerminalRouteList(router)
  return findAccessibleWorkspaceEntry(routes, WORKSPACE_GROUND_STATION, canAccess) ||
    findAccessibleWorkspaceEntry(routes, WORKSPACE_ADMIN, canAccess) ||
    fallback
}
